import { useEffect, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

// State
import { setCheckoutBonusesType } from '../../../state/modules/order/actions';
import { clearStock } from '../../../state/modules/stock/actions';

export default function useBonusesSwitcher() {
  const intl = useIntl();
  const dispatch = useDispatch();
  // бонусы за доставку (rewards[0]: {reward: "order_discount", reward_value: 25, type: "percent", applied: false, message: "Получите скидку 25% на заказ"})
  const pickupBonuses = useSelector(state => state.stock.unconditionalList.data.rewards?.[0]);
  // выбранное лойлти - бонусы или промокод (stockCode: {}, sailplay_discount: 26)
  const sailplayDiscount = useSelector(state => state.cart?.sailplay_discount);
  const stockCode = useSelector(state => state.stock.data.code);
  const deliveryType = useSelector(state => state.order.checkout.deliveryType);

  const bonusesTypes = useMemo(() => {
    const pickupLabelId =
      pickupBonuses?.reward === 'gift'
        ? 'bonusesSwitcher.takeawayGift'
        : 'bonusesSwitcher.takeawayDiscount';

    return [
      {
        value: 'another_bonuses',
        label: stockCode
          ? intl.formatMessage({ id: 'promocode.title' })
          : sailplayDiscount && intl.formatMessage({ id: 'checkout.bonus.count' }),
      },
      {
        value: 'pickup_bonuses',
        label: intl.formatMessage({ id: pickupLabelId }),
      },
    ];
  }, [stockCode, sailplayDiscount, pickupBonuses]);

  const isActive = useMemo(() => {
    return deliveryType === 'pickup' && Boolean(stockCode);
  }, [deliveryType, stockCode]);

  const handleChange = useCallback(
    value => {
      dispatch(setCheckoutBonusesType(value));

      // если выбираем скидку за самовывоз
      if (value === 'pickup_bonuses') {
        // очищаем только промокод; баллы и акционные товары остаются
        if (stockCode) {
          dispatch(clearStock());
        }
      }
    },
    [stockCode],
  );

  // при активации промокода возвращаем выбор к "another_bonuses"
  useEffect(() => {
    if (stockCode) {
      dispatch(setCheckoutBonusesType('another_bonuses'));
    }
  }, [stockCode]);

  return { bonusesTypes, isActive, handleChange };
}
